import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import About from "./sections/About";
import Team from "./sections/Team";
import Compromisos from "./sections/Compromisos";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <About />
      <Team />
      <Compromisos />
      <Footer />
    </div>;
}